import { TokenUsage } from './common.interface';
import {
    AIDisclosureParagraphEditType,
    AIDisclosureParagraphType,
} from '@/services/ai-disclosure/type/ai-disclosure.enum';
import { SSEStreamService } from '@patsnap-utils/sse/src/sse-stream-service.interface';

export interface ApiGetDisclosureContentRequest<ContentType> {
    task_id: string;
    current_step: string;
    content_type: ContentType;
    text?: string;
}

export type ApiGetDisclosureContentResponse = {
    content: string;
    token_usage: TokenUsage;
    status: string;
};

export const GetDisclosureContent = Symbol('GetDisclosureContent');

export interface GetDisclosureContent {
    getDisclosureContent(data: ApiGetDisclosureContentRequest<AIDisclosureParagraphEditType | AIDisclosureParagraphType>): SSEStreamService<ApiGetDisclosureContentResponse>;
}
